import { createContext, useContext } from 'react';

export type HqStoreCtx = {
  storeNo: number | null;
  setStoreNo: (n: number | null) => void;
};

export const HqStoreContext = createContext<HqStoreCtx>({ storeNo: null, setStoreNo: () => {} });

export const HQ_STORE_KEY = 'hq_store_no';

export function readStoredHqStoreNo(): number | null {
  try {
    const v = localStorage.getItem(HQ_STORE_KEY);
    const n = v !== null ? Number(v) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function useHqStore(): HqStoreCtx {
  return useContext(HqStoreContext);
}
